<div class="loader-overlay row mx-0 justify-content-center align-items-center">
  <div class="col-12">
    <img src="assets/images/IRR-Logo3.svg" class="loader-icon animated bounceIn infinite slow">
  </div>
</div>